<template>
  <div class="main_section">
    <div id="rains" class="rain front-row" v-html="drops">
    </div>
    <div class="visuals">
      <img id="name" src="https://static.igem.wiki/teams/4185/wiki/aestuarium-text-igem.png" alt="" class="name">
      <img id="ray" class="logo" src="https://static.igem.wiki/teams/4185/wiki/logo-trans-igem.png" alt="">
      <img id="arrow" @click="startFrontAnimation" class="arrow arrow-pulsate-animation" src="https://static.igem.wiki/teams/4185/wiki/arrow-igem-home.png" alt="">
    </div>
  </div>
</template>

<script>
// import { tSThisType } from '@babel/types';

export default {
  data () {
    return{
      drops: []
    }
  },
  mounted() {
    this.makeItRain()
    window.scrollTo({
        top: 0,
    });
    this.disableScroll()
  },
  methods: {
    // mouseEnter () {
      
    // },
    // mouseMove (event) {
    //   let x = event.clientX
    //   let x_percentage = x / document.body.clientWidth * 100


    //   // let y = event.clientY


    // },
    // mouseLeave () {
    //   //
    // },
    empty () {

      let element = document.getElementById('rain')
      // Get the element's children as an array
      let children = Array.prototype.slice.call(element.childNodes);

      // Remove each child node
      children.forEach(function (child) {
        element.removeChild(child);
      });
    },
    makeItRain () {
      //clear out everything
      // $('.rain').empty();
      this.drops = []

      var increment = 0;
      // var drops = "";

      while (increment < 100) {
        //couple random numbers to use for various randomizations
        //random number between 98 and 1
        var randoHundo = (Math.floor(Math.random() * (98 - 1 + 1) + 1));
        //random number between 5 and 2
        var randoFiver = (Math.floor(Math.random() * (5 - 2 + 1) + 2));

        // Math.floor(Math.random() * (max - min + 1)) + min;
        var randomLeft = Math.floor(Math.random() * (95 - 10 + 1)) + 5;
        //increment
        increment += randoFiver;
        //add in a new raindrop with various randomizations to certain CSS properties
        this.drops += '<div class="drop" style="left: ' + randomLeft + '%; bottom: ' + (randoFiver + randoFiver - 1 + 100) + '%; animation-delay: 0.' + randoHundo + 's; animation-duration: 0.5' + randoHundo + 's;"><div class="stem" style="animation-delay: 0.' + randoHundo + 's; animation-duration: 0.5' + randoHundo + 's;"></div><div class="splat" style="animation-delay: 0.' + randoHundo + 's; animation-duration: 0.5' + randoHundo + 's;"></div></div>';
      }
    },
    disableScroll () {
      document.body.classList.add("stop-scrolling");
      window.addEventListener('touchmove', this.preventDefault);
    },
    enableScroll () {
      document.body.classList.remove("stop-scrolling");
      window.removeEventListener('touchmove', this.preventDefault);
    },
    preventDefault(e) {
      e.preventDefault();
    },
    startFrontAnimation () {
      this.enableScroll()
      // document.getElementById("arrow").style.display = "none"
      document.getElementById('ray').classList.add('ray-animation')
      document.getElementById('name').classList.add('name-animation')
      document.getElementById('arrow').classList.remove('arrow-pulsate-animation')
      document.getElementById('arrow').classList.add('arrow-animation')

      setTimeout(function(){
        let anchor = document.querySelector('#start');
        anchor.scrollIntoView();
      },500);
    }
  }
}
  
</script>


<style lang="scss">
.drop {
  position: absolute;
  bottom: 100%;
  width: 15px;
  height: 120px;
  pointer-events: none;
  animation: drops 0.5s linear infinite;
}

.rain {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
}

  @keyframes drops {
    0% {
      transform: translateY(0vh);
    }
    // 25% {
    //   transform: translateY(90vh);
    // }
    // 50% {
    //   transform: translateY();
    // }
    // 75% {
      // transform: translateY(90vh);
    // }
    100% {
      transform: translateY(150vh);
    }
  }

  .stem {
    width: 3px;
    height: 60%;
    margin-left: 5px;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.25));
    animation: stems 0.5s linear infinite;
  }

  @keyframes stems {
    0% {
      opacity: 1;
    }
    65% {
      opacity: 1;
    }
    75% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }


  .main_section {
      width: 100%;
      height: 100vh;
      background: #397579;

      .visuals {
        .logo {
          width: 50%;
          left: 25%;
          position: absolute;
          animation-fill-mode: forwards;
          top: 5%;
        }

        .ray-animation {
          -webkit-animation-name: ray-animation-keyframes;
          -webkit-animation-duration: 1s;
          -webkit-animation-iteration-count: 1;
          -webkit-animation-timing-function: linear;
          -webkit-animation-fill-mode: forwards;

          animation-name: ray-animation-keyframes;
          animation-duration: 1s;
          animation-iteration-count: 1;
          animation-timing-function: linear;
          animation-fill-mode: forwards;

          // animation: mymove 1s linear;
        }

        @keyframes ray-animation-keyframes {
          // 0%   {}
          0%  {
            top: 5%;left: 25%; width: 50%; z-index: 0;
            // -ms-transform:rotate(30deg); /* IE 9 */
            // -moz-transform:rotate(30deg); /* Firefox */
            // -webkit-transform:rotate(30deg); /* Safari and Chrome */
            // -o-transform:rotate(30deg); /* Opera */
          }
          // 50%  {
          //   top: 18%; left: 20%; width: 35%;
          //   -ms-transform:rotate(-30deg); /* IE 9 */
          //   -moz-transform:rotate(-30deg); /* Firefox */
          //   -webkit-transform:rotate(-30deg); /* Safari and Chrome */
          //   -o-transform:rotate(-30deg); /* Opera */
          // }
          // 75%  {
          //   top: 28%; left: 35%; width: 40%;
          //   -ms-transform:rotate(15deg); /* IE 9 */
          //   -moz-transform:rotate(15deg); /* Firefox */
          //   -webkit-transform:rotate(15deg); /* Safari and Chrome */
          //   -o-transform:rotate(15deg); /* Opera */
          // }
          90% {
            z-index: 0;
          }
          100% {
            top: calc(65vh); left: calc((100% - 70vh) / 2 ); width: 70vh; z-index: 2;
            -ms-transform:rotate(0deg); /* IE 9 */
            -moz-transform:rotate(0deg); /* Firefox */
            -webkit-transform:rotate(0deg); /* Safari and Chrome */
            -o-transform:rotate(0deg); /* Opera */
          }
        }

        .arrow {
          width: 10%;
          left: 45%;
          position: absolute;
          top: 80%;
          cursor: pointer;
          z-index: 2;

          // &:hover {
          //   -ms-transform: scale(1.2); /* IE 9 */
          //   -webkit-transform: scale(1.2); /* Safari 3-8 */
          //   transform: scale(1.2); 
          // }
        }

        .arrow-pulsate-animation {
          animation-name: pulsate;
          animation-duration: 1s;
          animation-iteration-count: infinite;
        }

        @keyframes pulsate {
          0% {
            transform: scale(1.0);
            -ms-transform: scale(1.0); /* IE 9 */
            -webkit-transform: scale(1.0);
          }

          50% {
            transform: scale(1.2);
            -ms-transform: scale(1.2); /* IE 9 */
            -webkit-transform: scale(1.2);
          }

          100% {
            transform: scale(1.0);
            -ms-transform: scale(1.0); /* IE 9 */
            -webkit-transform: scale(1.0);
          }
        }

        .arrow-animation {
          animation-name: arrow-animation-keyframes;
          animation-duration: 0.5s;
          animation-fill-mode: forwards;
          animation-timing-function: ease-out;
        }

        @keyframes arrow-animation-keyframes {
          0% {top: 80%; opacity: 1}
          50% {top: 90%;}
          100% {top: 100%; opacity: 0;}
        }


        .name {
          position: absolute;
          width: 50%;
          left: 25%;
          top: 5%
        }

        .name-animation {
          animation-name: name-animation;
          animation-duration: 1.5s;
          animation-fill-mode: forwards;
          animation-timing-function: ease-in;
        }

        @keyframes name-animation {
          from {top: 5%}
          to {top: 25%;}
        }

      }
  }
</style>